import styled from 'styled-components'

export const StickyNav = styled.ul`
  position: -webkit-sticky;
  position: sticky;
  top: 1rem;
  ${(props) => (props.scrollable ? 'overflow-y: scroll; max-height: 95vh;' : null)}
  padding: 0;
  > li {
    list-style: none;
    padding: 0.8rem 1rem;
  }
`
